export default __webpack_public_path__ + "static/media/Heroking's Breastplate.6951cfd3.jpg";